const clamp = (min, max, v) => {
    if (v > max)
        return max;
    if (v < min)
        return min;
    return v;
};

export { clamp };
//# sourceMappingURL=clamp.mjs.map
